import { createHttpInstance } from "./httpService";
import http from "./httpService";

const edtechApiUrl =
  process.env.VUE_APP_EDTECH_API_URL ||
  "https://staging-surge-api.eddy4teachers.com";
const edtechHttp = createHttpInstance(`${edtechApiUrl}/api`);

class TermService {
  async getAllGrades() {
    return await edtechHttp.get("/grades");
  }

  async getAllSubjects() {
    return await edtechHttp.get("/subjects");
  }

  async getAllDomains() {
    return await edtechHttp.get("/domains");
  }

  async getAllSoftwares() {
    return await edtechHttp.get("/softwares");
  }

  async getAllStudentProfiles() {
    return await edtechHttp.get("/student-profiles");
  }

  async getTermsByName(param) {
    // const url = http.getUrlWithParams("/terms", param);
    return await http.get("/terms", param);
  }

  async getAllFilterAirtable(locale) {
    return await http.get(
      `/stem-studio/makercart/filters${locale ? `?locale=${locale}` : ""}`
    );
  }

  async getFilters(type) {
    return await edtechHttp.get(`/filters?type=${type}`);
  }
}

export default new TermService();
